export default {
    title: `Comment améliorer votre score?`,
    text1: `Votre score de crédibilité est basé sur la qualité de votre audience et le taux de comptes considérés comme “faux” parmi vos abonnés.`,
    text1b: `Plus vous en avez, plus votre score est bas. Sont considérés comme “faux comptes” :`,
    point1: `un compte ayant plus d’abonnements que d’abonnés,`,
    point2: `un compte sans photo de profil,`,
    point3: `un compte inactif ou sans post(s),`,
    text2: `Vous pouvez, à tout moment, surveiller et bloquer ces comptes. Cela améliorera notamment votre taux d’engagement.`,
};
